import { Injectable } from '@angular/core';
import { AlertController, NavController, ModalController, LoadingController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AlertService } from './alert.service';
import { ProjectsService } from './projects.service';
import { BaseAsset } from '../models/assets/BaseAsset';
import { AssetTypeService } from './asset-type.service';
import { MediaAsset } from '../models/assets/MediaAsset';
import { ApiAssetService } from '../api-services/asset.api.service';
import { ApiAssetOnAssetManagementPageService } from '../api-services/asset-on-management-page.api.service';
import { AssetOnAssetManagementPage } from '../models/assets/AssetOnAssetManagementPage';
import { ValidationService } from './validation.service';
import { AddAssetModalPage } from '../modals/add-asset-modal/add-asset-modal.page';
import { ViewAssetModalPage } from '../modals/view-asset-modal/view-asset-modal.page';
import { MessagesService } from './messages.service';
import { DeepCopyService } from './deep-copy.service';
import { FileSizeService } from './file-size.service';
import { FileService } from './file.service';
import { CustomerUsageService } from './customer-usage.service';
import { Router } from '@angular/router';
import { CryptoService } from './crypto.service';
import { ApiSceneService } from '../api-services/scene.api.service';

@Injectable({
  providedIn: 'root'
})
export class AssetManagementService {
  public assets: MediaAsset[] = null;
  public sizeTracking = 0;
  public sizeLimit = 20;
  public assetsCopy: MediaAsset[];
  public backgroundDefault: string = "/assets/DefaultProject.png";
  private _isModalOpen: boolean = false;
  public globalAssets: number[] = null;
  public backgroundAssets: number[] = null;

  public assetFilter = {
    name: '',
    assetTypeId: null,
    isGlobal: '',
    isBackground: '',
    mediaFileExtension: ''
  };

  constructor(
    public alertController: AlertController,
    public alertService: AlertService,
    public navController: NavController,
    private storage: Storage,
    public projectService: ProjectsService,
    public assetTypeService: AssetTypeService,
    public assetAPIService: ApiAssetService,
    public sceneAPIService: ApiSceneService,
    public assetOnManagePageService: ApiAssetOnAssetManagementPageService,
    public modalController: ModalController,
    public loadingController: LoadingController,
    public validationService: ValidationService,
    public messagesService: MessagesService,
    public deepCopyService: DeepCopyService,
    public fileSizeService: FileSizeService,
    public fileService: FileService,
    public customerUsageService: CustomerUsageService,
    public router: Router,
    public cryptoService: CryptoService
  ) {

    this.assets = [];
    // this.getAssetsOnManagementPage(); 

  }

  getAssetsOnManagementPage(): Promise<BaseAsset[]> {
    var ids = [];
    return new Promise<BaseAsset[]>(async (resolve) => {
      if (this.cryptoService.decryptData(localStorage.getItem("login_r")) != "sa") {
        this.assetOnManagePageService.getAssetsOnAssetManagementPageWithCustomerId(+this.cryptoService.decryptData(localStorage.getItem("customerId"))).subscribe(assetsOnManagementPages => {
          this.globalAssets = [];
          this.backgroundAssets = [];
          assetsOnManagementPages.forEach(assetsOnManagementPage => {
            if (!ids.includes(assetsOnManagementPage.baseAssetId)) {
              ids.push(assetsOnManagementPage.baseAssetId);
            }

            if (assetsOnManagementPage.isGlobal) {
              this.globalAssets.push(assetsOnManagementPage.baseAssetId);
            }

            if (assetsOnManagementPage.isBackground) {
              this.backgroundAssets.push(assetsOnManagementPage.baseAssetId);
            }
          });

          this.assetAPIService.getBaseAssetsWithBaseAssetIds(ids).subscribe(baseAssets => {
            this.assets = baseAssets as MediaAsset[];
            this.assets.forEach((asset: any, index) => {
              asset.size = this.fileSizeService.getFileSizeWithMetric(asset);
              if (this.globalAssets != null) {
                if (this.globalAssets.length != 0) {
                  if (this.globalAssets.includes(asset.baseAssetId)) {
                    asset.isGlobal = "true";
                  }
                  else {
                    asset.isGlobal = "false";
                  }
                }
                else {
                  asset.isGlobal = "false";
                }
              }
              else {
                asset.isGlobal = "false";
              }

              if (this.backgroundAssets != null) {
                if (this.backgroundAssets.length != 0) {
                  if (this.backgroundAssets.includes(asset.baseAssetId)) {
                    asset.isBackground = "true";
                  }
                  else {
                    asset.isBackground = "false";
                  }
                }
                else {
                  asset.isBackground = "false";
                }
              }
              else {
                asset.isBackground = "false";
              }
            });
            this.assetsCopy = baseAssets as MediaAsset[];
            this.updateAssetSize();
            resolve(baseAssets);
          });
        });
      }
      else {
        this.assetOnManagePageService.getGlobalAssetsOnAssetManagementPage().subscribe(assetsOnManagementPages => {
          this.globalAssets = [];
          this.backgroundAssets = [];
          assetsOnManagementPages.forEach(assetsOnManagementPage => {
            ids.push(assetsOnManagementPage.baseAssetId);
            if (assetsOnManagementPage.isGlobal) {
              this.globalAssets.push(assetsOnManagementPage.baseAssetId);
            }
            if (assetsOnManagementPage.isBackground) {
              this.backgroundAssets.push(assetsOnManagementPage.baseAssetId);
            }
          });

          this.assetAPIService.getBaseAssetsWithBaseAssetIds(ids).subscribe(baseAssets => {
            this.assets = baseAssets as MediaAsset[];
            this.assets.forEach((asset: any, index) => {
              asset.size = this.fileSizeService.getFileSizeWithMetric(asset);
              asset.isGlobal = "true";
              
              if (this.backgroundAssets != null) {
                if (this.backgroundAssets.length != 0) {
                  if (this.backgroundAssets.includes(asset.baseAssetId)) {
                    asset.isBackground = "true";
                  }
                  else {
                    asset.isBackground = "false";
                  }
                }
                else {
                  asset.isBackground = "false";
                }
              }
              else {
                asset.isBackground = "false";
              }
            });
            this.assetsCopy = baseAssets as MediaAsset[];
            this.updateAssetSize();
            resolve(baseAssets);
          });
        });
      }

    });
  }

  checkIfAssetIsGlobal(asset) {
    if (this.cryptoService.decryptData(localStorage.getItem("login_r")) == "sa") {
      return false;
    }
    else {
      if (asset.isGlobal == "true") {
        return true;
      }
      else {
        return false;
      }
    }
  }

  checkIfAssetIsBackground(asset) {
    if (asset.isBackground == "true") {
      return true;
    }
    else {
      return false;
    }
  }

  updateAssetSize() {
    var size = 0;

    this.assets.forEach(element => {
      size += element.fileSize;
    });
    this.sizeTracking = size;
  }

  async updateAssetSizeWithPromise() {
    await new Promise<void>((resolve) => {
      var size = this.assets.map(x => x.fileSize).reduce((a, b) => a + b, 0);
      this.sizeTracking = size;
      resolve();
    });
  }

  async createAsset(assetData, isBackground: boolean): Promise<MediaAsset> {
    await this.messagesService.presentLoadingWindow("Creating media.");
    var assetType = this.assetTypeService.getType(assetData.assetTypeId);

    var asset: any = {
      baseAssetId: 0,
      name: this.validationService.removeHtmlTags(assetData.name),
      description: assetData.description,
      assetManagementPageId: 1,
      assetTypeId: assetData.assetTypeId,
      fileSize: await this.fileSizeService.getFileSize(assetData.src),
      mediaFileExtension: assetData.mediaFileExtension,
      src: assetData.src,
      timeStamp: new Date().toISOString().slice(0, 19)
    };

    var mediaAssetPromise = new Promise<MediaAsset>((resolve, reject) => {
      this.assetAPIService.addMediaAsset(asset as MediaAsset, assetType).subscribe(assetFromDb => {
        this.addAssetOnManagementPage(assetFromDb.baseAssetId, isBackground);
        asset.baseAssetId = assetFromDb.baseAssetId;
        asset.isGlobal = "false";
        asset.isBackground = String(isBackground);
        asset.size = this.fileSizeService.getFileSizeWithMetric(asset);

        if (this.assetTypeService.getType(asset.assetTypeId) == 'Video') {
          let src = asset.src;
          asset.uploadStatus = 'uploading';
          asset.src = this.fileService.videoAssetUploadingPlaceholder;
          this.fileService.addVideoToCheckUploadStatus('managementPageBaseAsset', asset.baseAssetId, asset, src);
          this.fileService.initialiseVideoUploadStatusCheck();
        }

        this.updateAssetSize();
        this.messagesService.loadingWindow.dismiss();
        this.messagesService.savedSuccessfully('New Media');
        resolve(asset);
      });
    });

    return mediaAssetPromise;
  }

  async openAddAssetModal(asset) {
    await this.messagesService.presentLoadingWindow('Validating File Storage credits...');
    let fileStorageUsagePercentage: number = await this.customerUsageService.getFileStorageCreditsUsagePercentage();
    await this.messagesService.loadingWindow.dismiss();

    if (fileStorageUsagePercentage >= 100) {
      let alertResult = await this.addOrEditAssetAlert();
      if (alertResult === 'buy') {
        if (this.cryptoService.decryptData(localStorage.getItem("login_r")) == "ad")
          this.router.navigateByUrl('/my-account');
        else
          this.router.navigateByUrl('/contact-admin');
      }
      return;
    }

    if (asset != null) {
      return await this.editAsset(asset);
    }
    else {
      return await this.addAsset()
    }
  }

  async openViewAssetModal(asset) {

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    const modal = await this.modalController.create({
      component: ViewAssetModalPage,
      id: 'asset-preview-' + this.assetTypeService.getType(asset.assetTypeId) + '-modal',
      componentProps: {
        "assetModalData": asset
      }
    });

    modal.onDidDismiss().then(() => {
      this._isModalOpen = false;
    });

    return await modal.present();
  }

  async addAsset() {

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    const addModal = await this.modalController.create({
      component: AddAssetModalPage,
      id: 'add-asset-modal',
    });

    addModal.onDidDismiss().then(async result => {
      if (result.data != null) {
        let mediaAsset = await this.createAsset(result.data.asset, result.data.isBackground);
        this.assets.push(mediaAsset);
      }
      this._isModalOpen = false;
    });
    return await addModal.present();
  }

  async editAsset(asset) {
    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    let isBackground: boolean = asset.isBackground == "true" ? true : false;
    let oldSrc: string = asset.src;

    const editModal = await this.modalController.create({
      component: AddAssetModalPage,
      id: 'add-asset-modal',
      componentProps: {
        "asset": this.deepCopyService.deepCopy(asset),
        "isEditing": true,
        "isBackground": isBackground
      }
    });

    editModal.onDidDismiss().then(result => {
      if (result.data != null && result.data.asset.name != null && result.data.asset.src != null) {
        let newSrc = result.data.asset.src;
        this.updateAsset(result.data.asset);

        if(isBackground == true){
          this.updateScenesSrc(oldSrc, newSrc);
        }
      } else {
        this.resetAsset(asset.baseAssetId);
      }
      this._isModalOpen = false;
    });
    return await editModal.present();
  }

  async updateAsset(asset) {
    var assetType = this.assetTypeService.getType(asset.assetTypeId);
    await this.messagesService.presentLoadingWindow(`Updating media: ${asset.name}`);

    asset.fileSize = await this.fileSizeService.getFileSize(asset.src);
    this.assetAPIService.updateMediaAsset(asset.baseAssetId, asset as MediaAsset, assetType).subscribe(async x => {
      this.updateAssetSize();
      var assetToUpdate = this.assets.find(a => a.baseAssetId == asset.baseAssetId);
      assetToUpdate.name = asset.name;
      assetToUpdate.description = asset.description;
      assetToUpdate.assetTypeId = asset.assetTypeId;
      assetToUpdate.fileSize = await this.fileSizeService.getFileSize(asset.src);
      assetToUpdate.mediaFileExtension = asset.mediaFileExtension;
      assetToUpdate.src = asset.src;

      if (this.assetTypeService.getType(assetToUpdate.assetTypeId) == 'Video') {
        let src = assetToUpdate.src;
        assetToUpdate.uploadStatus = 'uploading';
        assetToUpdate.src = this.fileService.videoAssetUploadingPlaceholder;
        this.fileService.addVideoToCheckUploadStatus('managementPageBaseAsset', assetToUpdate.baseAssetId, assetToUpdate, src);
        this.fileService.initialiseVideoUploadStatusCheck();
      }

      this.messagesService.loadingWindow.dismiss();
      this.messagesService.savedSuccessfully('Media');
    });

  }

  resetAsset(baseAssetId: number) {
    this.assetAPIService.getBaseAsset(baseAssetId).subscribe(asset => {
      var a: any = this.assets.filter(a => a.baseAssetId == baseAssetId)[0];
      a.name = asset.name;
      a.description = asset.description;
    })
  }


  addAssetOnManagementPage(assetId: number, isBackground: boolean) {
    var assetOnManagementPage: AssetOnAssetManagementPage = new AssetOnAssetManagementPage();
    assetOnManagementPage.baseAssetId = assetId;
    assetOnManagementPage.assetOnAssetManagementPageId = 0;
    assetOnManagementPage.isGlobal = this.cryptoService.decryptData(localStorage.getItem("login_r")) != "sa" ? false : true;
    assetOnManagementPage.isBackground = isBackground;
    this.assetOnManagePageService.addAssetOnAssetManagementPage(assetOnManagementPage).subscribe();
  }

  checkIfOverStorageLimit(fileSize) {
    if (fileSize + this.sizeTracking > this.sizeLimit) {
      this.alertService.presentActionConfirmationAlert("You have exceeded your fair usage policy amount. You may be charged if you continue to upload files.", "Asset limit", true);
    }
  }

  reinitAssets() {
    this.assets = this.assetsCopy;
  }

  async launchAsset(asset) {
    window.open(asset.fileUrl, '_system');
  }

  async deleteAsset(asset) {
    const alert = await this.alertController.create({
      header: 'Please confirm',
      message: "are you sure you want to delete the media '" + asset.name + "'?",
      buttons: [{
        text: 'Cancel',
      }, {
        text: 'Delete',
        handler: () => {
          asset.active = false;
          this.messagesService.presentLoadingWindow("Deleting Media...");
          this.assetAPIService.deleteBaseAsset(asset.baseAssetId).subscribe(res => {
            this.removeScenesSrc(asset.src);
            this.messagesService.loadingWindow.dismiss();
          });
          var assetIndexToBeDeleted = this.assets.indexOf(asset);
          this.assets.splice(assetIndexToBeDeleted, 1);
          this.updateAssetSize();
          this.messagesService.deletedSuccessfully("Media");
        }
      }
      ]
    });
    await alert.present();
  }

  getAssetType(id) {
    return this.assetTypeService.getType(id);
  }

  getAssetTypeId(type) {
    return this.assetTypeService.types.find(x => x.type == type).assetTypeId;
  }

  addOrEditAssetAlert(): Promise<string> {
    return new Promise<string>(async (resolve) => {
      let message: string = `You have used all your file storage credits. Do you want to buy more credits?`;

      const alert = await this.alertController.create({
        header: 'Media Management',
        message: message,
        cssClass: 'leave-alert',
        backdropDismiss: true,
        buttons: [{
          text: 'Go To Account Page',
          cssClass: 'leave-button',
          handler: () => {
            resolve('buy');
          }
        }]
      });

      alert.onDidDismiss().then((eventDetail) => {
        if (eventDetail.role === 'backdrop') {
          resolve('');
        }
      });

      await alert.present();
    });
  }

  async updateScenesSrc(oldSrc: string, newSrc: string){
    let scenes = await this.sceneAPIService.getScenesWithBackgroundSrc(oldSrc).toPromise();
    scenes.forEach(async scene => {
      scene.sceneBackgroundSrc = newSrc;
      await this.sceneAPIService.updateScene(scene.sceneId, scene).subscribe();
    });
  }

  async removeScenesSrc(oldSrc: string){
    let scenes = await this.sceneAPIService.getScenesWithBackgroundSrc(oldSrc).toPromise();
    scenes.forEach(async scene => {
      scene.sceneBackgroundSrc = "";
      scene.sceneBackgroundFileType = "";
      scene.sceneBackgroundColour = "#dddddd";
      await this.sceneAPIService.updateScene(scene.sceneId, scene).subscribe();
    });
  }
}
